import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaBackward, FaBan, FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { extract } from '../../../util/util';
import { toast } from 'react-toastify';
import MostrarHTML from '../../../components/MostrarHtml';
import Alert from '../../../components/Alert';
import { FinField } from '../../../components/FinField';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import '../../../css/financeiro-parcela-pagar.css';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';

export default function CadastroEventoParticipanteAceitarTermo({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [data, setData] = useState(null);
    const [concordaTermo, setConcordaTermo] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    // Modelo da carta barrado pela trava do evento: troca o card vazio por um aviso traduzido.
    const [cartaIndisponivel, setCartaIndisponivel] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    var idEvento = state?.evento ?? null;
    const idioma = getIdiomaCodigo();

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        setCartaIndisponivel(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //o back decide a etapa (proximoStep). Se esta tela ('termo') não é a atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'termo') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            api({
                method: "get",
                action: '/eventoCarta/visualizarCartaHtml/' + id,
                token: token,
                params: {
                    tipoCarta: "modelotermoaceite",
                }
            }).then(response => {
                setData({
                    ...dadosRecebidos,
                    ...{ htmlCartaConvite: response.data.data.htmlCarta }
                });
                setIsLoading(false);
            }).catch(function (error) {
                // A trava de seguranca do evento barrou o modelo desta carta: a API responde com
                // `code: carta_indisponivel`. Aviso fixo e traduzido dentro do card — o toast
                // generico fechava em 3,5 s e deixava o convidado diante de um card vazio, sem
                // saber que precisa falar com a organizacao do evento.
                if (error?.response?.data?.code === 'carta_indisponivel') {
                    setCartaIndisponivel(true);
                } else {
                    toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
                }
                setIsLoading(false);
                setIsError(true);
            });
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const salvar = (aceitouTermo) => {
        setIsSubmitting(true);
        api({
            method: 'put',
            action: '/participante/aceitarTermo/' + id,
            token: token,
            data: { executarAceitouTermo: aceitouTermo ? 'sim' : 'nao' },
        })
            .then(function () {
                toast.success(getText('dadosSalvosSucesso'));
                if (!aceitouTermo) {
                    history.push("/cadastroEventoParticipanteConviteRecusado/" + data?.evento?.id);
                    return;
                }
                //aceite do termo: o back resolve a próxima etapa (overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: data?.evento?.id, contrato, setLoading: setIsLoading });
            })
            .catch(function () {
                toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                {['listarsvp'].includes(perfil) && (
                    <div style={{ marginBottom: 12 }}>
                        <button
                            type="button"
                            className="fin-pp__btn"
                            onClick={() => history.push("/eventoParticipante/" + idEvento)}
                        >
                            <FaBackward size={14} style={{ marginRight: 6 }} />Participantes
                        </button>
                    </div>
                )}

                {/* Carta / Convite HTML */}
                <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                    {cartaIndisponivel && (
                        <div className="fin-pp__banner is-warn">
                            <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                            <span>{getText('cartaIndisponivel')}</span>
                        </div>
                    )}
                    <MostrarHTML
                        htmlContent={data?.htmlCartaConvite ?? null}
                    />
                </div>

                {/* Termo LGPD */}
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">{getText('termoLgpd')}</h1></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo1')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo2')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo3')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo4')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo5')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('lgpdInfo6')}</p>
                    <p style={{ color: 'var(--fin-tx)', marginBottom: 16 }}>
                        {getText('downloadTerms')}{' '}
                        <a rel="noreferrer" target="_blank" href={process.env.REACT_APP_API_URL + "/termo_lgpd.pdf"}>
                            {getText('downloadLgpdTerms')}
                        </a>
                    </p>

                    {!isLoading && !isError && data?.evento && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', color: 'var(--fin-tx)' }}>
                                    <input
                                        type="checkbox"
                                        value={concordaTermo}
                                        checked={concordaTermo}
                                        onChange={() => {
                                            setConcordaTermo(!concordaTermo);
                                        }}
                                    />
                                    {getText('agreeWithTerms')}
                                </label>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--danger"
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        Alert({
                                            title: getText('temCerteza'),
                                            icon: "warning",
                                            html: <>{getText('lgpdWarning')}</>,
                                            confirmButton: getText('voltar'),
                                            denyButton: getText('naoAceitoOsTermosConfirm'),
                                            callBack: (result) => {
                                                if (result.isDenied) {
                                                    salvar(false);
                                                }
                                            },
                                        });
                                    }}
                                >
                                    {isSubmitting ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />{getText('salvando')}</>
                                    ) : (
                                        <><FaBan size={16} style={{ marginRight: 6 }} />{getText('naoAceitoOsTermos')}</>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    disabled={!concordaTermo || isSubmitting}
                                    onClick={() => {
                                        salvar(true);
                                    }}
                                >
                                    {isSubmitting ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />{getText('salvando')}</>
                                    ) : (
                                        <><FaCheck size={16} style={{ marginRight: 6 }} />{getText('aceitoOsTermos')}</>
                                    )}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </ErpTemplate>
    );
}
